import { render } from "./workStart2026.vue?vue&type=template&id=246598a5&scoped=true"
import script from "./workStart2026.vue?vue&type=script&lang=ts"
export * from "./workStart2026.vue?vue&type=script&lang=ts"

import "./workStart2026.vue?vue&type=style&index=0&id=246598a5&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-246598a5"

export default script